$(document).ready(function() {
    $('input[type="tel"]').mask('+7 999 999-9999', { autoclear: false }, { placeholder: '+7             ' });
    $('input.timepicker').timepicker({
        timeFormat: 'h:mm',
        dynamic: false,
        dropdown: true,
        scrollbar: true
    });


    new AirDatepicker('.date-input', {
        locale: localeRu,
        autoClose: true,
        onSelect: () => {
            $(".date-input").addClass("input-active")
        }
    })


    fix100vh()
    $(window).resize(function() {
        fix100vh()
    })


});

function fix100vh() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}

let fancybox = document.querySelectorAll("[data-fancybox]")

Fancybox.defaults.placeFocusBack = false
